import { axios } from 'api'
import useDownload from 'hooks/useDownload'
import React from 'react'

const Button = ({ bonusId, file }) => {
  const { downloadFile } = useDownload()

  const handleClick = (e) => {
    e.preventDefault()
    axios
      .post(`/bonus_items/${bonusId}/download`, { platform: 'web' })
      .then(() => {})
      .catch((err) => console.log(err))
      .finally(() => downloadFile(file))
  }
  return (
    <div className='bonus-content-bottom'>
      <a onClick={handleClick} href='#!' className='download-button'>
        Download
        <i className='fa fa-arrow-down' />
      </a>
    </div>
  )
}

export default Button
